/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
var Container = styled.div.withConfig({
  displayName: "Modalstyles__Container",
  componentId: "sc-1qzenqe-0"
})(["padding-top:15px;display:flex;@supports (display:grid){display:grid;}position:relative;background:", ";overflow-x:hidden;> svg{height:72px;}"], function (props) {
  return props.theme.color.monochrome.light;
});
var SkeletonWrapper = styled.div.withConfig({
  displayName: "Modalstyles__SkeletonWrapper",
  componentId: "sc-1qzenqe-1"
})(["padding:0 15px 10px;background:", ";"], function (props) {
  return props.theme.color.monochrome.light;
});
var ButtonSpacer = styled.div.withConfig({
  displayName: "Modalstyles__ButtonSpacer",
  componentId: "sc-1qzenqe-2"
})(["", ";", ";&:only-child{margin:auto;padding:0;}@media only screen and (max-width:", "){padding-left:0;padding-right:0;}"], function (props) {
  return props.type === 'continue' && css(["padding-right:5px;"]);
}, function (props) {
  return props.type === 'att' && css(["padding-left:5px;@media only screen and (max-width:", "){margin-bottom:10px;}"], props.theme.size.breakpoint['max-width'].xs);
}, function (props) {
  return props.theme.size.breakpoint['max-width'].xs;
});
export { ButtonSpacer, Container, SkeletonWrapper };